import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import useSelfServiceFlags from "hooks/useSelfServiceFlags";
import { Stack } from "types/generated";
import { AccessResult, hasAtLeastWriteAccess, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

import { checkTemplateDeploymentAccess } from "./helpers/checkTemplateDeploymentAccess";

// FYI: the "stack.canWrite" check here is for legacy stacks (could be affected by access policies)
const useHasStackWriteAccess = (): ((stack?: Stack) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);
  const { enableSelfServiceV2 } = useSelfServiceFlags();

  return useCallback(
    (stack?: Stack) => {
      if (!stack) {
        return { result: false };
      }

      const blueprintCheck = checkTemplateDeploymentAccess(enableSelfServiceV2, stack);
      if (blueprintCheck) {
        return blueprintCheck;
      }

      if (viewer.admin) {
        return { result: true };
      }

      if (stack.canWrite) {
        return { result: true };
      }

      const result = hasAtLeastWriteAccess(viewer, stack.spaceDetails?.id || stack.space);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer, enableSelfServiceV2]
  );
};

export default useHasStackWriteAccess;
